import { AssetDto } from "../dtos/assetDto";
import { Asset } from "../models/asset";
import { BigNumber } from "../models/bigNumbers";
import ApiService from "../services/api";
import { fetchComplementaryAssetsDetails } from "./fetchAssets";
import { fetchVehiclesFromOccurrences } from "./fetchVehiclesFromOccurrences";

export interface IAssetSummary {
  id: string;
  identification: string;
  name: string;
}

let cancelAbortController: AbortController | undefined;
export const fetchMaintenance = async (assetsSummary: IAssetSummary[]): Promise<[Asset[], BigNumber?]> => {
  if(cancelAbortController) cancelAbortController.abort();
  cancelAbortController = new AbortController();

  if(!assetsSummary || assetsSummary?.length === 0) {
    cancelAbortController = undefined;
    return [[], undefined];
  }

  const apiService = new ApiService();

  try {
    const response = await apiService.post<any>(`/maintenance`, {assets: assetsSummary}, { signal: cancelAbortController.signal });
    if (response.status === 200) {
      const maintenanceList = response.data.list || [];

      const assetIds = maintenanceList
        .map((el: any) =>
          el.vehicle?.assetId ??
          el.vehicle?.asset?.id ??
          el.vehicle?.asset?.assetId ??
          el.vehicle?.assetid ??
          el.vehicle?.assetID ??
          el.assetId ??
          el.asset?.id ??
          el.asset?.assetId ??
          el?.id ??
          el?.vehicleId
        )
        .filter((assetId: string | undefined) => !!assetId);

      const chassisList = maintenanceList
        .map((el: any) =>
          el.vehicle?.chassis ??
          el.vehicle?.identification ??
          el.vehicle?.vin ??
          el.vehicle?.chassi ??
          el.vehicle?.asset?.chassis ??
          el.vehicle?.asset?.identification ??
          el.vehicle?.asset?.vin ??
          el.vehicle?.asset?.chassi ??
          el.vehicle?.plateNumber ??
          el.vehicle?.vehicleIdentificationNumber
        )
        .filter((chassis: string | undefined) => !!chassis);

      const [complementaryDetails, vehiclesFromOccurrences] = await Promise.all([
        assetIds.length ? fetchComplementaryAssetsDetails(assetIds) : Promise.resolve([]),
        chassisList.length ? fetchVehiclesFromOccurrences(chassisList) : Promise.resolve([]),
      ]);

      const assets = maintenanceList.map((el: any) => {
        const vehicleAssetId =
          el.vehicle?.assetId ??
          el.vehicle?.asset?.id ??
          el.vehicle?.asset?.assetId ??
          el.vehicle?.assetid ??
          el.vehicle?.assetID ??
          el.assetId ??
          el.asset?.id ??
          el.asset?.assetId ??
          el?.id ??
          el?.vehicleId;

        const vehicleChassis =
          el.vehicle?.chassis ??
          el.vehicle?.identification ??
          el.vehicle?.vin ??
          el.vehicle?.chassi ??
          el.vehicle?.asset?.chassis ??
          el.vehicle?.asset?.identification ??
          el.vehicle?.asset?.vin ??
          el.vehicle?.asset?.chassi;

        const assetSummary = assetsSummary.find((asset: IAssetSummary) => asset.id === vehicleAssetId);
        const complementary = complementaryDetails.find((c: any) => c.id === vehicleAssetId);
        const occurrenceVehicle = vehiclesFromOccurrences.find((v: any) => v.chassis === (vehicleChassis || assetSummary?.identification));
        const volkstotalInfo = el.volkstotal ?? el.VolksTotal ?? el.volksTotal ?? el.volks_total ?? el.vehicle?.volkstotal ?? el.vehicle?.VolksTotal ?? el.vehicle?.volksTotal;
        const contractNumberFromElapsed = volkstotalInfo?.contractNumber ?? volkstotalInfo?.contractnumber ?? volkstotalInfo?.contract;

        const plateFromPayload = el.vehicle?.plate;
        const plateFromComplementary = complementary?.licensePlate;
        const plateFromOccurrence = occurrenceVehicle?.licensePlate;

        const finalPlate = (plateFromPayload && plateFromPayload !== '-')
          ? plateFromPayload
          : (plateFromComplementary && plateFromComplementary !== '-')
            ? plateFromComplementary
            : (plateFromOccurrence && plateFromOccurrence !== '-')
              ? plateFromOccurrence
              : undefined;

        const vehicleWithPlate = {
          ...el.vehicle,
          chassis: assetSummary?.identification || vehicleChassis || el.vehicle?.chassis,
          name: assetSummary?.name || el.vehicle?.name,
          contractNumber: contractNumberFromElapsed ?? el.vehicle?.contractNumber ?? el.vehicle?.contractnumber ?? el.vehicle?.contract,
          plate: finalPlate !== undefined ? finalPlate : el.vehicle?.plate,
        };

        return AssetDto({
          ...el,
          volkstotal: volkstotalInfo ?? el.volksTotal ?? el.volkstotal ?? el.volks_total,
          vehicle: vehicleWithPlate,
          previousCheckups: null,
          nextCheckups: null,
        });
      });
      cancelAbortController = undefined;
      return [
        assets,
        //BigNumberDto(response.data.bigNumbers, assets)
      ];
    } else {
      cancelAbortController = undefined;
      return [[]];
    }
  } catch (error: any) {
    if(error.code === "ERR_CANCELED") throw new Error("ERR_CANCELED");
    cancelAbortController = undefined;
    console.error(error);
    return [[]];
  }
};
